module.exports = __webpack_public_path__ + "img/order.04943945.svg";